import {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'

export const copilotAgentsAppBuilder = DataRouterApplicationBuilder.create('copilot-agents')
